{
  "ProductionTemplateCreateModal": {
    "includeBudgeting": "包括预算",
    "customise": "自定义",
    "newTemplate": "新制作模板",
    "description": "为您的公司创建和编辑制作模板",
    "saveChanges": "保存更改",
    "updateFailed": "更新失败",
    "defaultIcon": "默认图标",
    "defaultColor": "默认颜色",
    "defaultCode": "默认代码",
    "defaultTitle": "默认标题",
    "defaultNumberOfDays": "默认天数",
    "defaultTags": "默认标签",
    "shotflowInstance": "Shotflow实例",
    "noInstance": "未选择实例",
    "requiredField": "此字段为必填项",
    "workspaceSetup": "工作区设置",
    "callsheets": "通告单",
    "deleteTemplate": "删除模板",
    "deleteConfirmationTitle": "您确定要删除此制作模板吗？",
    "deleteConfirmationButton": "删除模板",
    "newBudgetGroup": "新预算组",
    "newBudgetExpense": "新预算费用",
    "createTemplate": "创建制作模板",
    "editTemplate": "编辑制作模板",
    "templateName": "模板名称",
    "namePlaceholder": "名称",
    "fieldRequired": "此字段为必填项",
    "cancel": "取消",
    "updatedSuccessfully": "更新成功",
    "locations": "地点",
    "crew": "团队",
    "stages": {
      "templateDetails": {
        "title": "模板详情",
        "desc": "设置您的模板描述"
      },
      "productionDefaults": {
        "title": "制作默认值",
        "desc": "设置制作时自动填充各字段的默认数据"
      },
      "resourceDefaults": {
        "title": "资源默认值",
        "desc": "为该模板设置资源默认值，以便让用户了解该生产需要哪些资源。"
      }
    }
  },
  "resourcingViewModeTablistLabel": "计划、实际与预算",
  "resourcingPageTitlePlanned": "计划",
  "resourcingPageTitleActuals": "实际",
  "productionListViewOptions": "视图选项",
  "productionListShowResourcingBudgetColumn": "预算",
  "productionListBudgetChartModeLabel": "预算图表",
  "productionListBudgetChartVsPlanned": "对账 vs 计划",
  "productionListBudgetChartVsBudget": "计划与对账 vs 预算",
  "productionListCrewColumnLabel": "团队",
  "productionListCrewBookedShort": "已订",
  "productionListCrewCellAria": "已订角色：{{booked}} / {{total}}",
  "productionListCrewPercentTitle": "已订 {{percent}}% 角色",
  "productionListCrewCompleteTitle": "所有角色已订",
  "productionListCrewNoRoles": "无角色",
  "productionListBudgetColumnLabel": "预算",
  "productionListBudgetPlannedShort": "计划",
  "productionListBudgetActualShort": "实际",
  "productionListBudgetCellAria": "预算 {{target}}，计划 {{planned}}，已对账 {{reconciled}}",
  "productionListBudgetCellAriaNoReconciled": "预算 {{target}}，计划 {{planned}}，暂无对账合计",
  "productionListBudgetCellAriaVsPlanned": "计划 {{planned}}，已对账 {{reconciled}}",
  "productionListBudgetCellAriaVsPlannedNoReconciled": "计划 {{planned}}，暂无对账合计",
  "productionListBudgetCellAriaPlannedOnly": "计划 {{planned}}，暂无实际合计",
  "productionListBudgetNoReconciled": "无对账",
  "productionListBudgetNoActual": "无实际",
  "productionListBudgetTargetMarkerTitle": "制作预算 100%",
  "productionListBudgetPlanMarkerTitle": "计划金额 100%",
  "productionDetailNotesTitle": "备注",
  "productionDetailFilesTitle": "文件",
  "resourcingFooterBookedBadgeAria": "已填角色：{{booked}} / {{total}}",
  "resourcingFooterTotalPlanned": "计划合计 {{amount}}",
  "resourcingFooterTotalActual": "实际合计 {{amount}}",
  "resourcingViewLoadingAria": "正在加载资源配置",
  "resourcingDragOverlayAria": "正在拖动资源配置项",
  "resourcingDragOverlayKindGroup": "组",
  "resourcingDragOverlayKindRole": "角色",
  "resourcingDragOverlayKindExpense": "支出",
  "resourcingDragOverlayKindResourceLine": "指派",
  "resourcingDragOverlayKindExpenseLine": "支出行",
  "resourcingSlotCategoryPlaceholder": "选择类别",
  "resourcingSlotExpensePlaceholder": "选择支出",
  "resourcingGridColumnGroupName": "组",
  "resourcingGridColumnItemName": "条目",
  "resourcingGridColumnOrderAria": "槽位编号",
  "resourcingGridColumnRate": "费率",
  "resourcingGridColumnQtyUnit": "数量 / 单位",
  "resourcingGridColumnSubtotal": "小计",
  "resourcingGridColumnFees": "费用",
  "resourcingGridColumnExpenses": "支出",
  "resourcingGridColumnTotal": "总计",
  "resourcingItemAddResource": "添加资源",
  "resourcingItemAddExpense": "添加支出",
  "resourcingExpenseLineEditTitle": "编辑支出",
  "resourcingExpenseLineCreateTitle": "添加支出",
  "resourcingExpenseLineEditCategory": "支出类别",
  "resourcingExpenseLineEditName": "支出名称",
  "resourcingExpenseLineEditCancel": "取消",
  "resourcingExpenseLineEditSave": "保存更改",
  "resourcingExpenseLineCreateSave": "添加支出",
  "resourcingExpenseLineEditClose": "关闭",
  "resourcingItemBookingDetails": "详情",
  "resourcingItemResourceLoadError": "无法加载资源",
  "resourcingAssignDialogSearchResources": "搜索资源",
  "resourcingAssignDialogSelectResources": "选择资源",
  "resourcingAssignDialogSelectedCount_one": "已选择 {{count}} 项",
  "resourcingAssignDialogSelectedCount_other": "已选择 {{count}} 项",
  "resourcingAssignDialogUnselectAll": "取消全选",
  "resourcingAssignDialogNoResourcesFound": "未找到资源",
  "resourcingAssignDialogLoadFailed": "加载资源失败",
  "resourcingAssignDialogDefaultRateLabel": "默认费率：{{rate}}",
  "resourcingAssignDialogNoRole": "无角色",
  "resourcingAssignDialogNoDefaultRate": "无费率",
  "resourcingAssignDialogConflictCount_one": "{{count}} 个冲突",
  "resourcingAssignDialogConflictCount_other": "{{count}} 个冲突",
  "resourcingAssignDialogApplyPlannedEstimate": "将计划估算应用到已分配资源",
  "resourcingAssignDialogPlannedEstimate": "计划估算",
  "resourcingAssignDialogAppliedToCount_one": "已应用到 {{count}} 个资源",
  "resourcingAssignDialogAppliedToCount_other": "已应用到 {{count}} 个资源",
  "resourcingAssignDialogAssignedBookingsToBeCreated": "将创建的已分配预订",
  "resourcingAssignDialogNext": "下一步",
  "resourcingAssignDialogBack": "返回",
  "resourcingAssignDialogAssignResource": "分配资源",
  "resourcingAssignDialogAssignFailed": "未能分配，请重试。",
  "resourcingAssignDialogWorkspaceUnknown": "工作区未知：无法读取该制作，因此不进行搜索。",
  "resourcingAssignDialogSlot": "角色：{{name}}",
  "resourcingAssignDialogPick": "选入此角色",
  "resourcingAssignDialogAlreadyAssigned": "已在此制作中",
  "resourcingAssignDialogAvailable": "{{dates}} 可用",
  "resourcingAssignDialogAvailableValue": "可用",
  "resourcingAssignDialogAvailableSubject": "在制作日期内",
  "resourcingAssignDialogBookingsInDates": "制作日期内的预订",
  "resourcingDetailsOpenBookingAria": "打开预订",
  "resourcingDocsOpenBookingInvoicesAria": "打开预订发票与收据",
  "resourcingDocsOpenExpenseReceiptsAria": "打开支出收据",
  "resourcingDocsAddLabel": "添加",
  "resourcingGridColumnPlannedTotal": "计划总额",
  "resourcingGridColumnInvoicesReceipts": "发票 / 收据",
  "resourcingGridColumnActualsTotal": "实际总额",
  "resourcingGridColumnVariance": "差异",
  "resourcingPendingExpenseLineAria": "正在创建支出行",
  "resourcingAddExpensePickCategoryFirst": "请先在本行选择支出类别（或在设置中添加类别），再添加明细行。",
  "resourcingCreateExpenseFailed": "无法添加支出行",
  "resourcingNewExpenseVendorPlaceholder": "新支出",
  "resourcingRowActionsColumnLabel": "操作",
  "resourcingRowActionsMenuLabel": "打开行操作菜单",
  "resourcingRowActionsDeleteRole": "删除角色",
  "resourcingRowActionsDeleteExpenseSlot": "删除支出",
  "resourcingRowActionsRemoveAssignment": "移除资源",
  "resourcingRowActionsDeleteExpenseLine": "删除支出行",
  "resourcingRowActionsDuplicateRole": "复制角色",
  "resourcingRowActionsDuplicateExpenseSlot": "复制支出槽位",
  "resourcingRowActionsExcludeCostsFromBudget": "从预算中排除成本",
  "resourcingRowActionsIncludeCostsInBudget": "将成本计入预算",
  "resourcingSlotContextMenuAddResource": "添加资源",
  "resourcingSlotContextMenuAddExpense": "添加支出",
  "resourcingRowContextSendBooking": "发送预订更新",
  "resourcingPageActionsMenuLabel": "操作",
  "resourcingPageActionsSendBookingUpdates": "发送预订更新",
  "resourcingPageActionsSendBookingUpdatesNoPermission": "您没有发送预订更新的权限。如需访问，请联系管理员。",
  "resourcingPageActionsBatchAddToShortlist": "批量添加到短名单",
  "sendBookingConfirmationDialog": {
    "title": "发送预订更新",
    "titleBulk": "发送预订更新",
    "description": "确认将使用的确认模板，然后发送邮件。",
    "descriptionBulk": "确认将使用的确认模板，然后向本制作中所有符合条件的预订发送更新。",
    "scopeOrganizationTitle": "组织（全局）模板",
    "scopeOrganizationDescription": "此邮件将使用组织（全局）确认模板。",
    "scopeWorkspaceTitle": "工作区模板 · {{workspace}}",
    "scopeWorkspaceFallback": "工作区",
    "scopeWorkspaceDescription": "此邮件将使用该工作区的确认模板。",
    "scopeWorkspaceFallbackToGlobal": "此工作区没有覆盖模板，将使用组织（全局）模板。",
    "editTemplateLink": "编辑确认模板",
    "recipientLabel": "收件人",
    "recipientValue": "{{name}} · {{email}}",
    "recipientsBulkCount_one": "{{count}} 位收件人",
    "recipientsBulkCount_other": "{{count}} 位收件人",
    "recipientsBulkEmpty": "本制作中没有等待确认的已确认预订。",
    "recipientsBulkNoneReady": "目前无法发送邮件。请为上方列出的联系人添加邮箱。",
    "recipientsMissingEmailMessage": "这些资源没有邮箱，将被跳过。",
    "recipientProblemMissingEmail": "无邮箱",
    "recipientsLoadFailed": "无法加载此制作的收件人。",
    "previewPrevious": "上一位收件人预览",
    "previewNext": "下一位收件人预览",
    "previewPosition": "{{current}} / {{total}}",
    "unknownRecipient": "资源",
    "noEmailInline": "该资源没有电子邮件地址。发送前请先添加邮箱。",
    "templatePreviewLabel": "邮件预览",
    "templatePreviewHint": "这是将发送给联系人的内容",
    "templateEmpty": "此范围尚未配置确认模板。",
    "templateLoadFailed": "无法加载确认模板。",
    "cancel": "取消",
    "send": "发送",
    "sendSuccess": "预订确认已发送",
    "sendSuccessBulk": "预订更新已发送",
    "sendFailed": "发送预订更新失败",
    "missingTemplateDescription": "没有预订确认模板时无法发送。请添加确认模板后继续。",
    "goToTemplates": "前往确认模板"
  },
  "resourcingContextMenuSectionRow": "此行",
  "resourcingContextMenuSubmenuSlot": "角色/支出 · {{name}}",
  "resourcingContextMenuSubmenuSlotUnnamed": "角色/支出",
  "resourcingContextMenuOtherLevels": "其他层级",
  "resourcingContextMenuSubgroup": "分组 · {{name}}",
  "resourcingGroupContextMenuAddRole": "添加角色",
  "resourcingGroupContextMenuAddExpense": "添加支出",
  "resourcingGroupContextMenuDuplicate": "复制分组",
  "resourcingGroupContextMenuDelete": "删除分组",
  "resourcingGroupBookedAvailableCounter": "{{booked}}/{{available}}",
  "resourcingGroupNamePlaceholder": "未命名分组",
  "resourcingAddGroup": "添加分组",
  "resourcingSyncAllSaved": "已保存",
  "resourcingSyncSavingWithCount": "保存中（{{count}}）",
  "resourcingSyncSomeFailed": "保存失败",
  "resourcingSyncActivityHeading": "同步活动",
  "resourcingSyncActivityAutoScroll": "自动滚动",
  "resourcingSyncActivityToggleAria": "显示或隐藏同步活动详情",
  "resourcingSyncPauseOnline": "暂停在线同步",
  "resourcingSyncResumeOnline": "恢复在线同步",
  "resourcingSyncPaused": "在线同步已暂停",
  "resourcingSyncPausedWithCount": "{{count}} 项等待同步",
  "resourcingSyncActivityStatus_executing": "同步中",
  "resourcingSyncActivityStatus_queued": "排队中",
  "resourcingSyncActivityStatus_staged": "待处理",
  "resourcingSyncActivityStatus_awaiting_resume": "等待恢复同步",
  "resourcingSyncActivityStatus_success": "已保存",
  "resourcingSyncActivityStatus_error": "失败",
  "resourcingAction.default": "更改已保存",
  "resourcingAction.default_pending": "保存更改",
  "resourcingAction.updateSlotNote": "备注已更新",
  "resourcingAction.updateSlotNote_pending": "更新备注",
  "resourcingAction.updateSlotIncludeInCalculationIncluded": "已纳入计算",
  "resourcingAction.updateSlotIncludeInCalculationIncluded_pending": "纳入计算",
  "resourcingAction.updateSlotIncludeInCalculationExcluded": "已排除计算",
  "resourcingAction.updateSlotIncludeInCalculationExcluded_pending": "排除计算",
  "resourcingAction.updateSlotCategory": "类别已更新",
  "resourcingAction.updateSlotCategory_pending": "更新类别",
  "resourcingAction.reorderSlots": "槽位已重新排序",
  "resourcingAction.reorderSlots_pending": "重新排序槽位",
  "resourcingAction.reorderGroups": "分组已重新排序",
  "resourcingAction.reorderGroups_pending": "重新排序分组",
  "resourcingAction.createResourceSlot": "已添加角色",
  "resourcingAction.createResourceSlot_pending": "添加角色",
  "resourcingAction.duplicateResourceSlot": "角色已复制",
  "resourcingAction.duplicateResourceSlot_pending": "复制角色",
  "resourcingAction.duplicateBudgetExpense": "费用槽位已复制",
  "resourcingAction.duplicateBudgetExpense_pending": "复制费用槽位",
  "resourcingAction.addBudgetExpense": "已添加费用",
  "resourcingAction.addBudgetExpense_pending": "添加费用",
  "resourcingAction.createResourceAssignments": "已分配资源",
  "resourcingAction.createResourceAssignments_pending": "分配资源",
  "resourcingAction.createBudgetExpenseLine": "已添加费用行",
  "resourcingAction.createBudgetExpenseLine_pending": "添加费用行",
  "resourcingAction.deleteResourceSlot": "角色已删除",
  "resourcingAction.deleteResourceSlot_pending": "删除角色",
  "resourcingAction.deleteBudgetExpense": "费用已删除",
  "resourcingAction.deleteBudgetExpense_pending": "删除费用",
  "resourcingAction.deleteExpenseLine": "费用行已删除",
  "resourcingAction.deleteExpenseLine_pending": "删除费用行",
  "resourcingAction.deleteResourceSlotAssignment": "分配已移除",
  "resourcingAction.deleteResourceSlotAssignment_pending": "移除分配",
  "resourcingAction.createProductionGroup": "分组已创建",
  "resourcingAction.createProductionGroup_pending": "创建分组",
  "resourcingAction.duplicateProductionGroup": "分组已复制",
  "resourcingAction.duplicateProductionGroup_pending": "复制分组",
  "resourcingAction.updateProductionGroup": "分组已重命名",
  "resourcingAction.updateProductionGroup_pending": "重命名分组",
  "resourcingAction.deleteProductionGroup": "分组已删除",
  "resourcingAction.deleteProductionGroup_pending": "删除分组",
  "resourcingAction.updateResourceSlotPlanRates": "角色计划费率和费用已更新",
  "resourcingAction.updateResourceSlotPlanRates_pending": "更新角色计划费率和费用",
  "resourcingAction.updateAssignedResourceLineInterval": "预订间隔已更新",
  "resourcingAction.updateAssignedResourceLineInterval_pending": "更新预订间隔",
  "resourcingAction.updateResourceLineQtyUnit": "数量和单位已更新",
  "resourcingAction.updateResourceLineQtyUnit_pending": "更新数量和单位",
  "resourcingAction.updateResourceLineFees": "费用已更新",
  "resourcingAction.updateResourceLineFees_pending": "更新费用",
  "resourcingAction.updateBookingRate": "预订费率已更新",
  "resourcingAction.updateBookingRate_pending": "更新预订费率",
  "resourcingAction.updateBookingFees": "预订费用已更新",
  "resourcingAction.updateBookingFees_pending": "更新预订费用",
  "resourcingAction.updateBookingRatesAndFees": "预订费率和费用已更新",
  "resourcingAction.updateBookingRatesAndFees_pending": "更新预订费率和费用",
  "resourcingAction.updateBookingExpenseLines": "预订费用已更新",
  "resourcingAction.updateBookingExpenseLines_pending": "更新预订费用",
  "resourcingAction.updateBookingStatus": "预订状态已更新",
  "resourcingAction.updateBookingStatus_pending": "更新预订状态",
  "resourcingAction.updateBudgetExpensePlanRateFields": "费用计划费率已更新",
  "resourcingAction.updateBudgetExpensePlanRateFields_pending": "更新费用计划费率",
  "resourcingAction.updateBudgetExpensePlanQuantity": "费用计划数量已更新",
  "resourcingAction.updateBudgetExpensePlanQuantity_pending": "更新费用计划数量",
  "resourcingAction.updateBudgetExpensePlanRates": "费用计划已更新",
  "resourcingAction.updateBudgetExpensePlanRates_pending": "更新费用计划",
  "resourcingAction.updateExpenseLineCommittedRateFields": "费用行费率已更新",
  "resourcingAction.updateExpenseLineCommittedRateFields_pending": "更新费用行费率",
  "resourcingAction.updateExpenseLineCommittedQuantity": "费用行数量已更新",
  "resourcingAction.updateExpenseLineCommittedQuantity_pending": "更新费用行数量",
  "resourcingAction.updateExpenseLineCommittedRates": "费用行已更新",
  "resourcingAction.updateExpenseLineCommittedRates_pending": "更新费用行",
  "resourcingLeaveWhileSavingTitle": "更改仍在保存中",
  "resourcingLeaveWhileSavingDescription": "部分更改仍在保存到服务器。如果现在离开，保存将在后台继续进行。",
  "resourcingLeaveWhileSavingConfirm": "仍然离开",
  "resourcingLeaveWhileSavingCancel": "继续编辑",
  "resourcingLeaveWhileSavingBeforeUnload": "更改仍在保存中。确定要离开吗？",
  "resourcingRatesInlineTitleBooking": "预订成本",
  "resourcingRatesInlineTitleExpense": "支出成本",
  "resourcingRatesInlineTitleExpensePlan": "支出计划",
  "resourcingRatesInlineExpensePlanHint": "在此为槽位做预算。各支出行的已确认金额在下方编辑。",
  "resourcingCostSheetLaneExpensePlan": "该槽位计划",
  "resourcingCostSheetFooterExpensePlan": "支出计划合计",
  "resourcingCostSheetExpenseCommittedIntro": "该行的已确认费率；槽位计划在上方支出行。",
  "resourcingRatesInlineTabEstimated": "预估",
  "resourcingRatesInlineTabBooking": "预订",
  "resourcingRatesInlineTabExpenseActual": "已确认",
  "resourcingRatesInlineSectionRate": "费率",
  "resourcingRatesInlineSectionFees": "费用",
  "resourcingRatesInlineSectionExpenses": "支出",
  "resourcingCostSheetSectionResourceRate": "资源费率",
  "resourcingCostSheetSectionResourceEstimateRate": "资源预估费率",
  "resourcingCostSheetSectionResourceActualRate": "资源实际费率",
  "resourcingCostSheetSectionFees": "费用",
  "resourcingCostSheetSectionResourceExpenses": "资源支出",
  "resourcingRatesInlineAddExpense": "添加支出",
  "resourcingRatesInlineEmptyBooking": "分配人员后可编辑。",
  "resourcingRatesInlineEmptyExpenseActual": "设置已确认费率后可编辑。",
  "resourcingRatesInlineTitleSlotEstimate": "角色预估",
  "resourcingRatesInlineSlotEstimateHint": "在此做计划；预订在分配行。",
  "resourcingCostSheetBookingIntroRowContext": "预订成本；计划在上方角色行。",
  "resourcingCostSheetLanePlan": "计划",
  "resourcingCostSheetLaneBooked": "已订",
  "resourcingCostSheetExpenseIntro": "预估与已确认。",
  "resourcingCostSheetLaneEstimate": "预估",
  "resourcingCostSheetLaneCommitted": "已确认",
  "resourcingCostSheetFooterPlan": "计划合计",
  "resourcingCostSheetFooterBooked": "已订合计",
  "resourcingCostSheetFooterEstimate": "预估合计",
  "resourcingCostSheetFooterCommitted": "已确认合计",
  "resourcingCostSheetCalculationResourceEstimate": "资源预估",
  "resourcingCostSheetCalculationResourceActual": "资源实际",
  "resourcingCostSheetCalculationExpenseEstimate": "支出预估",
  "resourcingCostSheetCalculationExpenseActual": "支出实际",
  "resourcingCostSheetLaneRolePlan": "该角色计划",
  "resourcingCostSheetFooterRolePlan": "角色计划合计",
  "resourcingCostSheetRemoveExpenseAria": "删除支出",
  "resourcingCostSheetExpenseCategory": "类别",
  "resourcingCostSheetExpenseVendor": "名称",
  "resourcingCostSheetExpenseColumnTotal": "合计",
  "resourcingSlotEstimateQuantity": "数量",
  "resourcingSlotEstimateFeesHeading": "费用",
  "resourcingSlotEstimateFeeAgency": "代理费",
  "resourcingSlotEstimateFeePayroll": "薪酬费",
  "resourcingSlotEstimateFeeProcessing": "处理费",
  "resourcingSlotEstimateFeeAgencyAria": "包含代理费",
  "resourcingSlotEstimateFeePayrollAria": "包含薪酬费",
  "resourcingSlotEstimateFeeProcessingAria": "包含处理费",
  "resourcingCostSheetFeeColumnAgency": "代理费",
  "resourcingCostSheetFeeColumnPayroll": "薪酬费",
  "resourcingCostSheetFeeColumnProcessing": "处理费",
  "resourcingCostSheetFeePercentInputAgency": "代理费百分比",
  "resourcingCostSheetFeePercentInputPayroll": "薪酬费百分比",
  "resourcingCostSheetFeePercentInputProcessing": "处理费百分比",
  "resourcingBudgetFeesPopoverRateSubtotal": "费率小计",
  "resourcingBudgetFeesPopoverFeeTotal": "费用合计",
  "resourcingBudgetBookingExpensesDescriptionPlaceholder": "说明",
  "resourcingBudgetBookingExpensesCreate": "添加支出",
  "resourcingBudgetBookingExpensesIncompleteRow": "保存前请填写完整的支出信息",
  "resourcingBudgetBookingExpensesTotal": "支出合计",
  "resourcingBookingStatusSelectAria": "选择预订状态",
  "resourcingBookingStatusGroupBooking": "预订",
  "resourcingBookingStatusGroupAvailability": "档期",
  "productionDetailStatusSelectAria": "选择制作状态",
  "productionDetailStatusSearchPlaceholder": "搜索状态…",
  "productionDetailStatusGroupUser": "用户操作",
  "productionDetailStatusGroupAutomated": "自动操作",
  "productionDetailNoteCreatedToast": "备注已添加",
  "productionDetailNoteCreateErrorToast": "无法添加备注",
  "productionDetailNoteDeletedToast": "备注已删除",
  "productionDetailNoteDeleteErrorToast": "无法删除备注",
  "productionDetailNoteDeleteAria": "删除备注",
  "productionDetailNotesFieldLabel": "新备注",
  "productionDetailNotesLoadError": "无法加载备注。",
  "productionDetailNotesEmptyTitle": "暂无备注",
  "productionDetailNotesEmptyDescription": "为 {{name}} 添加备注。",
  "productionDetailNotesEmptyFallbackName": "此制作",
  "productionDetailNotesUnknownUser": "未知用户",
  "productionDetailNotesPlaceholder": "写备注…",
  "productionDetailNotesSubmit": "添加备注",
  "productionDetailFileUploadedToast": "文件已上传",
  "productionDetailFileUploadErrorToast": "上传失败",
  "productionDetailFileReorderErrorToast": "无法保存新的顺序",
  "productionDetailFilesLoadError": "无法加载文件。",
  "productionDetailFilesEmptyTitle": "暂无文件",
  "productionDetailFilesEmptyDescription": "为 {{name}} 上传简报、参考或合同。",
  "productionDetailFilesEmptyFallbackName": "此制作",
  "productionDetailFileUntitled": "未命名文件",
  "TransferProductionDialog": {
    "title": "转移到工作区",
    "description_one": "将 {{name}} 移至其他工作区和团队。",
    "description_other": "将 {{count}} 个制作移至其他工作区和团队。",
    "fieldCurrentWorkspace": "当前工作区",
    "fieldWorkspace": "目标工作区",
    "fieldTeam": "目标团队",
    "selectWorkspace": "选择工作区",
    "selectTeam": "选择团队",
    "save": "转移",
    "transferFailed": "转移失败",
    "success_one": "制作已转移",
    "success_other": "已转移 {{count}} 个制作"
  },
  "ProductionActions": {
    "transfer": "转移到工作区"
  },
  "SlotResourcePicker": {
    "assign": "分配",
    "moreWays": "更多分配方式",
    "assignAndConfirm": "分配并确认",
    "assignWithStatus": "按状态分配",
    "assignAndEdit": "分配并编辑",
    "notApplied": "未应用此角色搜索中的条件：",
    "availability": "可用性",
    "sort": "排序",
    "operators": {
      "s_with": "开头为",
      "e_with": "结尾为",
      "match": "全部",
      "any": "任意",
      "sort": "按",
      "from_date": "从",
      "to_date": "至",
      "status": "状态为"
    },
    "assignFailed": "未能分配，请重试。",
    "assignAndEditOneOnly": "多个资源时不可用：请选择一个以编辑其预订。"
  }
}
